import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map, Placemark, withYMaps } from 'react-yandex-maps';
import { MAP_DEFAULT_ZOOM, MARKER_OPTIONS } from './constants';
import { isNil } from 'lodash';
import styles from './YaMapComponent.module.scss';
import cn from 'classnames';
import YaMapUnavailable from './YaMapUnavailable';
import Loading from 'components/Loading';
import REACT_CONFIG from 'REACT_CONFIG';

const centerDefault = [55.75, 37.57];

class YaMapComponent extends Component {
  componentDidUpdate(prevProps) {
    if (prevProps.address !== this.props.address) {
      this.getCoordinates();
    }
  }

  getCoordinates = () => {
    const { addressId, address, getCoordinates, ymaps } = this.props;
    getCoordinates(ymaps, addressId, address);
  };

  renderMap = () => {
    const { coordinates, addressId } = this.props;
    const currentCoordinates =
      !isNil(coordinates) && coordinates.get(addressId) ? coordinates.get(addressId).toJS() : null;

    return (
      <Map
        width="100%"
        height="100%"
        defaultState={{
          center: centerDefault,
          zoom: MAP_DEFAULT_ZOOM,
        }}
        state={
          currentCoordinates ? { center: currentCoordinates, zoom: MAP_DEFAULT_ZOOM } : undefined
        }
        modules={['geolocation', 'geocode']}
        onLoad={this.getCoordinates}
      >
        {currentCoordinates && <Placemark geometry={currentCoordinates} options={MARKER_OPTIONS} />}
      </Map>
    );
  };

  render() {
    const { isFixedHeight, isMapLoading, isMapError } = this.props;

    if (REACT_CONFIG.REACT_APP_HIDE_MAPS) {
      return null;
    }

    return (
      <div className={cn(styles.yaContainer, { [styles.yaContainerFixed]: isFixedHeight })}>
        {!isMapError && this.renderMap()}
        {isMapLoading && <Loading />}
        {isMapError && <YaMapUnavailable />}
      </div>
    );
  }
}

YaMapComponent.propTypes = {
  addressId: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  coordinates: PropTypes.object,
  isMapLoading: PropTypes.bool,
  isMapError: PropTypes.object,
  getCoordinates: PropTypes.func,
  isFixedHeight: PropTypes.bool,
  ymaps: PropTypes.object.isRequired,
};

export default withYMaps(YaMapComponent);
